import { formatDateWithMonthName } from '../../MainDashboard/Common/formatters';
import { STATUS_COPY } from '../enquiryDisplay';

const REFERENCE_PATTERN = /^\d{1,10}$/;

export const NOT_YET = 'Not yet';

export const isValidEnquiryReference = (reference) =>
    typeof reference === 'string' && REFERENCE_PATTERN.test(reference);

export const getTimelineNodes = (detail) => {
    const createdText = formatDateWithMonthName(detail?.createdOn);
    const inProgressText = formatDateWithMonthName(detail?.inProgressOn);
    const resolvedText = formatDateWithMonthName(detail?.resolvedOn);

    const states = {
        Received: [
            { state: 'current', dateText: createdText },
            { state: 'todo', dateText: NOT_YET },
            { state: 'todo', dateText: NOT_YET },
        ],
        InProgress: [
            { state: 'done', dateText: createdText },
            { state: 'current', dateText: inProgressText },
            { state: 'todo', dateText: NOT_YET },
        ],
        Complete: [
            { state: 'done', dateText: createdText },
            { state: 'done', dateText: inProgressText },
            { state: 'done', dateText: resolvedText },
        ],
    }[detail?.status] || [
        { state: 'done', dateText: createdText },
        { state: 'todo', dateText: NOT_YET },
        { state: 'todo', dateText: NOT_YET },
    ];

    const labels = [
        { key: 'received', label: STATUS_COPY.Received.label },
        { key: 'in-progress', label: STATUS_COPY.InProgress.label },
        { key: 'complete', label: STATUS_COPY.Complete.label },
    ];

    return labels.map((node, index) => ({ ...node, ...states[index] }));
};

export const getOriginContent = (detail) => {
    const hasText = typeof detail?.submittedText === 'string' && detail.submittedText.trim().length > 0;

    if (detail?.origin === 'Portal') {
        return {
            showSubmittedSection: hasText,
            sectionTitle: 'What you sent us',
            originNote: null,
        };
    }

    if (detail?.origin === 'Agent') {
        return {
            showSubmittedSection: hasText,
            sectionTitle: 'Original enquiry',
            originNote: 'This enquiry was raised for you by a member of our team.',
        };
    }

    if (detail?.origin === 'Email') {
        return {
            showSubmittedSection: false,
            sectionTitle: null,
            originNote: "This enquiry reached us by email. For data protection reasons its content isn't shown here.",
        };
    }

    return { showSubmittedSection: false, sectionTitle: null, originNote: null };
};

export const getBreadcrumb = (detail) => {
    const parts = [detail?.utilityType, detail?.queryType, detail?.optionName]
        .map((part) => (typeof part === 'string' ? part.trim() : ''))
        .filter((part) => part.length > 0);

    return parts.length > 0 ? parts.join(' › ') : null;
};
